export default __webpack_public_path__ + "static/media/stripe.08c00111.svg";